import { render, staticRenderFns } from "./SubcontractorLabourAgreementCard.vue?vue&type=template&id=0e9a9900"
import script from "./SubcontractorLabourAgreementCard.vue?vue&type=script&lang=ts"
export * from "./SubcontractorLabourAgreementCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports